import { AxiosGlobalFilters } from '../config';
import { getAllProvidersAdapter } from 'adapters/providers';

const ProviderService = {
  getAll: ({ fornecedorId }) =>
    getAllProvidersAdapter(
      AxiosGlobalFilters({
        method: 'get',
        url: `/v1/empresas/fornecedor`,
        params: {
          fornecedorId,
        },
      }),
    ),
};

export { ProviderService };
